<template>
  <span class="input-clear-button">
    <i class="bi bi-x"></i>
  </span>
</template>

<script>
export default {
  name: 'InputClearIcon'
}
</script>

<style lang="scss" scoped>
  .input-clear-button {
    position: absolute;
    right: 2px;
    z-index: 2;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
    line-height: 0;
    font-size: 1.5em;
    color: #89181A;
  }
</style>